<template>
  <div class="download-btn" @click="handleDownload">
    <slot></slot>
  </div>
</template>
<script>
import { handleDownloadClick } from '@/utils/index'
export default {
  name: 'DownloadBtn',
  props: ['url', 'fileName'],
  methods: {
    handleDownload() {
      const { url, fileName } = this

      handleDownloadClick(url, fileName)
    }
  }
}
</script>
<style lang="scss" scoped>
.download-btn { display: inline-block; }
</style>
